<div class="layout-sidebar bg-surface-0 dark:bg-surface-900">
  <rb-menu></rb-menu>
</div>
